// extracted by mini-css-extract-plugin
module.exports =  {"projects":"_9330de7794--projects--pJP3G","projects__title":"_9330de7794--projects__title--qX3J1"};